import CreatableSelect from 'react-select/creatable';
import { MultiValue } from 'react-select/dist/declarations/src';
import theme from '../../assets/styles/themes/default';

interface StyledSelect2Props {
  placeholder: string;
  setValues: (values: MultiValue<unknown>) => void;
  value: any;
}

export const StyledSelect2 = ({
  placeholder,
  setValues,
  value,
}: StyledSelect2Props) => (
  <div style={{ width: '100%' }}>
    <CreatableSelect
      isMulti
      isClearable
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          padding: '5px',
          fontWeight: 400,
          fontSize: '12px',
          color: theme.colors.gray[500],
          height: 'auto',
          minHeight: 48,
          borderRadius: 8,
          border: `1px solid ${theme.colors.gray[400]}`,
          boxShadow: 'none',
          '&:hover': { borderColor: 'none' },
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          fontWeight: 400,
          fontSize: '12px',
        }),
        menuPortal: (baseStyles) => ({
          ...baseStyles,
          zIndex: 9999,
        }),
      }}
      onChange={(values) => setValues(values)}
      formatCreateLabel={(newItem) => <span>{`Criar ${newItem}...`}</span>}
      value={value}
      noOptionsMessage={() => null}
    />
  </div>
);
